import React from "react";
import EntriesTable from "./EntriesTable";
import WagerTypes from "../constants/WagerTypes";

const Superfecta = ({
  raceInfo,
  entriesInfo,
  idSuperfecta,
  idBox,
  addToCart,
  disabledAll,
  checkBoxState,
}) => {
  return (
    <>
      <div
        className="tab-pane fade show active"
        id="Superfecta"
        role="tabpanel"
        aria-labelledby="Superfecta"
      >
        <EntriesTable
          raceInfo={raceInfo}
          entriesInfo={entriesInfo}
          wt={WagerTypes.SUPERFECTA.name}
          idWT={idSuperfecta}
          idBox={idBox}
          addToCart={addToCart}
          disabledAll={disabledAll}
          checkBoxState={checkBoxState}
        />
      </div>
    </>
  );
};

export default Superfecta;
